import React from 'react';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Badge } from '../../../../CommonComponents/OPL/Badge/Badge';
import { Dot } from '../../../../CommonComponents/OPL/Dot/Dot';
import { Wrapper } from './Hero.styles';
import { CategoryResult } from '../../../api/useResultsQuery';
import { usePulseCheckTheme } from '../../../hooks/usePulseCheckTheme';
import { CategoryGauge } from '../../../components/CategoryGauge/CategoryGauge';

interface Props {
  categories: CategoryResult[];
}

export const Hero = ({ categories }: Props) => {
  const theme = usePulseCheckTheme();

  return (
    <Wrapper py="24">
      <Text
        textTransform="uppercase"
        color="white"
        fontSize="h6"
        fontWeight={600}
        css="letter-spacing: 1px"
      >
        Priorities for Your Wellbeing
      </Text>

      <Box display="flex" justifyContent="space-between" px={32} css="gap: 32px">
        {categories.map(({ id, fulfillment, icon: CategoryIcon }, index) => (
          <Box key={id} display="flex" flexDirection="column" alignItems="center" css="gap: 24px">
            <CategoryGauge
              size={170}
              categoryName={id}
              fulfillment={fulfillment}
              CategoryIcon={CategoryIcon}
            />

            <Badge variant="secondary">{`#${index + 1} ${id}`}</Badge>
          </Box>
        ))}
      </Box>

      <Box display="flex" alignItems="center">
        <Dot bg={theme.colors.accentColor} mr="4" />
        <Text fontSize="small" fontWeight={500} color="white">
          Fulfillment
        </Text>
      </Box>
    </Wrapper>
  );
};
